module.exports = __webpack_public_path__ + "flags.png?416250f60d785a2e02f17e054d2e4e44";